import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';
import { PaginatedTrips } from '../../../interfaces/trips/paginatedStore.type';

const tryToFetchTrips = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedTrips>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/trips/filter?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/trips/filter?page=${pageNumber}&size=${pageSize}`;
    return deviceInfoAxios.post<PaginatedTrips>(url, data);
};

const tryToFetchAllTrips = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filter ?
        `${DEVICE_INFO_API_URL}/trips/export?search=${data?.filter}`
        : `${DEVICE_INFO_API_URL}/trips/export`
    return deviceInfoAxios.post(url, data?.data);
};

const tryToFetchAllJourneys = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/itineraries?size=30`
    return deviceInfoAxios.get(url);
};

const tryToFetchCabins = (): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/cabins`);
};

const tryToFetchTrains = (): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/trains`);
};

const tryToFetchCarriageTemplates = (): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/carriage-templates`);
};

const tryToFetchCarriageTemplatesWithCabinOptions = (tripId?: string): Promise<AxiosResponse<any>> => {
    const query = tripId ? `?tripId=${tripId}` : '';
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/carriage-templates/with-cabin-options${query}`);
};

const tryToCreateTrip = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.post(`${DEVICE_INFO_API_URL}/trips`, data);
};

const tryToFetchSingleTrip = (id: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/trips/${id}`);
};

const tryToEditTrip = (id: string, data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/trips/update/${id}`, data);
};

const tryToGetFeedbackStats = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-executive`, data);
};

const tryToUpdateTripStatus = (id: string, status: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.patch(`${DEVICE_INFO_API_URL}/trips/${id}/status`, { status });
};

const tryToDeleteTrip = (id: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.delete(`${DEVICE_INFO_API_URL}/trips/${id}`);
};

const tryToFetchRolesForTrip = (): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/staff-users/roles-for-trip`);
};

export const AdminTripsService = {
    tryToFetchTrips,
    tryToFetchAllTrips,
    tryToFetchCabins,
    tryToCreateTrip,
    tryToFetchSingleTrip,
    tryToEditTrip,
    tryToFetchTrains,
    tryToFetchAllJourneys,
    tryToGetFeedbackStats,
    tryToUpdateTripStatus,
    tryToDeleteTrip,
    tryToFetchCarriageTemplates,
    tryToFetchCarriageTemplatesWithCabinOptions,
    tryToFetchRolesForTrip,
};